import React, {useEffect, useMemo, useState} from 'react';
import {VStack} from "native-base";
import {t} from "../../../../../../services/i18n";
import FormInput from "../../../../../common/FormInput";
import {useSelector} from "react-redux";
import CustomCheckbox from "../../../../../common/CustomCheckbox";
import AdvanceSelect from "../../../../../common/AdvanceSelect";
import usePermissions from "../../../../../../services/Permissions";
import {SCHEDULE_CANCEL_REASON_SELECT} from "../../../../../../services/ConstHelper";
import {checkBoxHasDoctorJournal} from "../../../../../../services/Helpers";

const HugimCancellation = (props) => {
    const { defaultValues, onFieldChange, isSingle, isHug, displayComment, hideReason, isAppointment } = props;
    const doctor_journal_settings = useSelector(state => state.box?.box?.settings?.doctor_journal_settings);
    const boxCancelReasonOptions = useSelector(state => state.box.box?.boxCancelReasons?.filter(reason => reason.active));
    const scheduleCancelReasons = useSelector(state => state.box.box?.scheduleCancelReasons?.filter(reason => reason.active));
    const reasonSubmitAttempted = useSelector(state => state.schedule?.confirmationRes?.reasonSubmitAttempted);

    const [reasonId, setReasonId] = useState(defaultValues?.reasonId ?? null);
    const [comment, setComment] = useState(null);
    const [notify, setNotify] = useState(defaultValues?.notify ?? false);
    const {has} = usePermissions()

    const reasonOptions = useMemo(() => ((isHug ? boxCancelReasonOptions : scheduleCancelReasons) ?? []).map(reason => ({ ...reason, label: reason.name, value: reason.id })), [boxCancelReasonOptions, scheduleCancelReasons, isHug])
    const isRequiredReason = useMemo(() => isAppointment && checkBoxHasDoctorJournal({has}), [doctor_journal_settings]);

    useEffect(() => {
        onFieldChange({reasonId, comment, notify})
    }, [reasonId, comment, notify]);

    return (
        <VStack width={'100%'} mt={'1rem'}>
            {!hideReason &&
            <FormInput required={isRequiredReason} label={t(`${isHug ? 'hug' : 'session'}CancellationReasonLabel`)} width={'100%'} infoTooltip={t(`${isHug ? 'hug' : 'session'}CancellationReasonTooltip`)}>
                <AdvanceSelect type={SCHEDULE_CANCEL_REASON_SELECT}
                               placeholder={t('select')}
                               initValue={reasonId}
                               options={reasonOptions}
                               onChange={(res) => setReasonId(res?.id ?? null)}
                               isClearable={true}
                               isError={isRequiredReason && !reasonId && reasonSubmitAttempted}
                />
            </FormInput>}
            {displayComment && <FormInput value={comment} onChangeCallback={setComment} label={t('commentOptional')} rows={4} inputType={'multiline'} width={'100%'}/>}
            <CustomCheckbox text={t(`cancel-send-notifications${isSingle ? '-signle' : ''}`)} isChecked={notify} onChange={(val) => setNotify(val)} />
        </VStack>
    );
};

export default HugimCancellation;